<template>
  <div class="pages">
    <div class="top facab">
      <div class="fac d-guide">
        <div class="fac">
          <div v-for="(item ,index) in daohang" >
            <span v-if="(daohang.length -1) !== index" style="cursor: pointer;" @click="handleNavigation(item.type_id, index)"> {{ item.position_name }}</span>
            <span v-else> {{ item.position_name }}</span>
            <i v-if="(daohang.length -1) !== index" class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
      <div class="fac">
        <div style="cursor: pointer;font-size: 1.1428rem;" @click="gotomyorder">{{ $t("main.myOrder") }}({{ allTotal }})</div>
      </div>
    </div>
    <product-type id="section1" :class="isStikcy ? 'sticky' : ''"></product-type>
    <div class="pTitle"> {{feileitext}}</div>
    <div class="pBox">
      <div
          v-html="content"
          class="contentproduct"
          :style="guanggaoimg ? 'position: absolute': ''"
      >
      </div>
      <img v-if="guanggaoimg" :src="guanggaoimg" class="p-Img" />
    </div>
    <product-info
      id="section2"
      ref="childRef"
      @child-event="siteDaohang"
      @clickStep="clickStep"
    ></product-info>
    <!-- 筛选 -->
    <div v-if="defaultFilter === true" class="d-filter" id="filter" :class="{ isFixed: searchBarFixed, sticky: filterSticky }">
      <div class="facab">
        <div class="fac">
          <el-dropdown
            v-for="(item, index) in columns"
            :ref="'dropdown'+index"
            :key="index"
            trigger="click"
            placement="bottom-start"
            :hide-on-click="false"
          >
            <span class="el-dropdown-link">
              {{ item.title }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" placement="bottom-start">
              <el-input
                  v-model="tagsSearch[item.varname]"
                  :placeholder="$t('main.search')"
                  clearable
                  @change="searchTags(item)"
                  style="width: 180px;"
              >
                <template #append>
                  <i class="el-icon-search" @click="searchTags(item)"></i>
                </template>
              </el-input>
              <div class="dropdown-list">
                <el-dropdown-item
                    v-for="(v, ind) in item.searchResult"
                    v-if="v"
                    :key="v"
                >
                  <el-checkbox
                      :label="v"
                      v-model="item['checked'][ind]"
                  >
                  </el-checkbox>
                </el-dropdown-item>
              </div>
              <div class="dropdown-footer">
                <el-button class="btn" @click="handleConfirmDropdown(item, 'dropdown'+index)" >{{ $t('main.sure') }}</el-button>
                <el-button class="btn-close" @click="handleCloseDropdown('dropdown'+index)">{{ $t('main.cancel') }}</el-button>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="fac">
          <span class="Link" @click="gotolink(1)">{{
              $t("main.productFeatures")
            }}</span>
          |
          <span class="Link" @click="gotolink(2)">{{
              $t("main.productDetail")
            }}</span>
          |
          <span class="Link" @click="gotolink(3)">{{
              $t("main.productBuild")
            }}</span>
        </div>
      </div>
      <div v-if="tags.length > 0" class="filterBox">
        <span @click="handleResetSearch" class="reset-search">{{ $t("main.clear") }}</span>
        <el-tag
            v-for="item in tags"
            :key="item.name"
            closable
            @close="handleClose(item)"
        >
          <span class="title">{{ item.title }}:</span>{{ item.name }}
        </el-tag>
      </div>
      <div class="d-search">
        <el-input
            v-model="searchParam"
            :placeholder="$t('main.search')"
            clearable
            @keyup.enter.native="enterkey"
        >
          <template #append>
            <i class="el-icon-search" @click="enterkey"></i>
          </template>
        </el-input>
      </div>
      <div class="filterBox">
        <div>
          <div>
            <span>{{ $t("main.all") }}:{{ feileitext }}(<span class="number">{{ standardProductNum + frequentlyUsedProductNum }}</span>)</span>
            <span>{{ $t("main.standardProduct") }}(<span class="number">{{ standardProductNum }}</span>)</span>
            <span>{{ $t("main.frequentlyUsedProduct") }}(<span class="number">{{ frequentlyUsedProductNum }}</span>)</span>
          </div>
        </div>
      </div>
      <div v-if="defaultFilter === true" class="t-th fac table-title">
        <div class="td1"></div>
        <div class="td-r fac">
          <div class="td2">{{ $t("main.parameter") }}</div>
          <div
            class="th-n"
            v-for="item in tableTitle"
            :style="
                  'product_model' === item.varname ? 'min-width:180px;' :
                  ('stock' === item.varname || 'price' === item.varname ? 'min-width:70px;' :tableTitleStyle)
                "
            :key="item.id"
          >
            {{ item.title }}
          </div>
          <div class="th-n td14">{{ $t("main.compare") }}</div>
          <div class="th-n td15">{{ $t("main.shopCar") }}</div>
        </div>
      </div>
    </div>

    <!-- 产品列表 -->
    <product-table
        ref="productTable"
        @getExpand="handleColumns"
        :tags="tags"
        :searchParam="searchParam"
        :productImage="productImage"
        :typeId="typeId"
        @widthChange="widthChange"
        @getColumns="getColumns"
        @changeNum="changeNum"
    ></product-table>
  </div>
</template>

<script>
import ProductType from "./components/productType";
import ProductTable from "./components/productTable.vue";
import ProductInfo from "./components/productInfo.vue";
import { addShopcar } from "@/api/shopcar";
import { listOrder } from "@/api/order";
import Cookies from "js-cookie";
import {getProductInfo} from "@/api";

export default {
  components: {
    ProductType,
    ProductTable,
    ProductInfo
  },
  data() {
    return {
      searchParam: "",
      tagsSearch:[],
      site_id: 1,
      searchBarFixed: "",
      columns: [],
      tableTitle: [],
      daohang: [],
      daohangtext: "",
      guanggaoimg: "",
      tags: [],
      defaultFilter:-1,
      standardProductNum: 0,
      frequentlyUsedProductNum: 0,
      feileitext: "",
      content: "内容",
      allTotal: 0,
      isStikcy: true,
      tableTitleStyle: {},
      productImage: "",
      typeId: "",
      filterSticky: true,
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },
  watch: {
    "$store.state.siteInfo": function(newV, oldV) {
      if (newV) {
        this.site_id = newV;
        this.getOrderCount();
        if (typeof oldV != 'object') {
          this.handleResetSearch();
        }
      }
      this.searchParam = this.$route.query.keyword;
    }
  },
  async mounted() {
    this.searchParam = this.$route.query.keyword;
    this.$refs.productTable.getProductList(this.tags, this.searchParam);
    this.getOrderCount();
    this.handleJumpByAnchor();
  },
  methods: {
    handleJumpByAnchor() {
      window.addEventListener("scroll", this.scrollHandler);
      setTimeout(() => {
        if(this.$route.query.anchor) {
          this.scrollToAnchor(this.$route.query.anchor);
          window.removeEventListener("scroll", this.scrollHandler);
        }
      }, 1500);
    },
    handleNavigation(id, index) {
      if(index === 0) {
        this.$router.push({
          path: "/product"
        });
      } else {
        let params = {
          req: {
            id: id
          }
        };
        getProductInfo(params).then(res => {
          if(res.rsp.code === 0) {
            const item = res.data;
            if(index === 1) {
              this.$router.push({
                path: this.getRoutesPath('category_product', item['identification'], item['id'])
              });
            } else if (index > 1) {
              this.$router.push({
                path: this.getRoutesPath('category_product_more', item['identification'], item['id'])
              });
            }
          } else {
            this.$message({
              message: res.rsp.msg,
              type: "error",
            });
          }
        });
      }
    },
    clickStep() {
      this.scrollToAnchor("section2");
    },
    widthChange(data) {
      this.tableTitleStyle = data;
    },
    getColumns(data) {
      this.tableTitle = data;
    },
    // 跳转到个人中心-我的订单
    gotomyorder() {
      this.$router.push({ path: "/userCenter" });
    },
    // 获取我的订单数量
    getOrderCount() {
      const orderListParams = {
        req: {
          page: 1,
          limit: 1000,
          where: [
            {
              condition: "8",
              filed: "status",
              expression: "<>"
            },
            {
              condition: this.site_id.toString(),
              filed: "site_id",
              expression: "="
            }
          ],
          order: "id desc"
        }
      };
      listOrder(orderListParams).then((res) => {
        if (res.rsp.code === 0) {
          // 删选掉已删除的订单
          this.allTotal = res.data.total;
        }
      });
    },
    scrollToAnchor(anchorId) {
      const anchorElement = document.getElementById(anchorId);
      if (anchorElement) {
        window.scrollTo({
          top: anchorElement.offsetTop + 60,
          behavior: "smooth"
        });
      }
    },
    addGoodToCard: function(item) {
      // 购物车参数
      var params = {
        req: {
          product_id: 1,
          number: 3
        }
      };
      addShopcar(params).then((res) => {
        // this.codeUrl = "data:image/gif;base64," + res.data.image;
      });
    },
    handleColumns(val) {
      this.columns = val.map(item => {
        return {
          ...item,
          searchResult: item.values
        };
      })
    },
    searchTags(item) {
      item.searchResult = [];
      let tagsSearch = this.tagsSearch[item.varname];
      if (this.tagsSearch[item.varname]) {
        item.values.forEach(function (v, ind) {
          if (v.toLowerCase().includes(tagsSearch.toLowerCase())) {
            item.searchResult[ind] = v;
          }
        })
      }
    },
    gotolink(flag) {
      if (1 == flag) {
        this.scrollToAnchor("section1");
      }
      if (2 == flag) {
        this.scrollToAnchor("section2");
        this.$refs.childRef.productDetail();
      }
      if (3 == flag) {
        this.scrollToAnchor("section3");
      }
      if (4 == flag) {
        this.scrollToAnchor("section2");
        this.$refs.childRef.backonly();
      }
    },
    siteDaohang(data) {
      this.daohangtext = "";
      this.productImage = data.image;
      this.typeId = data.type_id;
      this.content = data.product_feature;
      this.guanggaoimg = data.product_feature_bg;
      this.daohang = data.wanhui_postion;

      for (var i = 0; i < this.daohang.length; i++) {
        this.daohangtext = this.daohangtext + this.daohang[i] + ">";
      }
      this.feileitext = this.daohang[this.daohang.length - 1]['type_name'];
      this.daohangtext = this.daohangtext.substring(
        0,
        this.daohangtext.length - 1
      );
    },
    handleClose(tag) {
      this.tags.forEach((keys, index) => {
        if (tag.name === keys.name && tag.type === keys.type) {
          this.tags.splice(index, 1);

          this.columns = this.columns.map(item => {
            if(tag.type === item.varname) {
              let tagIndex = item.values.findIndex(res=>{
                return res == keys.name;
              });
              item['checked'][tagIndex] = false;
            }
            return {
              ...item
            };
          })
        }
      });
    },
    handleCloseDropdown(ref) {
      this.$refs[ref][0].visible = false;
    },
    handleConfirmDropdown(item, ref) {
      item.values.forEach((v, ind) => {
        let tags = this.tags.filter(value => value.name === v && value.type === item.varname);
        if (item.checked[ind] && !tags.length) {
          this.tags.push({
            title:item.title,
            name: v,
            type: item.varname
          });
        } else if (!item.checked[ind] && tags.length) {
          this.tags.forEach((value, index) => {
            if(value.name === v && value.type === item.varname) {
              this.tags.splice(index, 1);
            }
          });
        }
      });
      this.handleCloseDropdown(ref);
    },
    handleResetSearch() {
      this.searchParam = null;
      this.tags = [];
      this.columns = this.columns.map(item => {
        let checked = item.values.map(v => false);
        return {
          ...item,
          checked: checked
        };
      });
      this.$refs.productTable.getProductList();
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
    changeNum(v) {
      this.frequentlyUsedProductNum = v.commonTotal;
      this.standardProductNum = v.standardTotal;
      if (this.defaultFilter === -1) {
        this.defaultFilter = v.commonTotal > 0 || v.standardTotal>0;
      }
    },
    enterkey() {
      this.$refs.productTable.getProductList(this.tags, this.searchParam);
    },
    scrollHandler() {
      let windowY = window.scrollY;
      let elementY = document.getElementById("section2").offsetTop;
      this.isStikcy = elementY - windowY >= 80;
      let clientH = document.getElementById('filter').clientHeight;
      let filterY = document.getElementById('section3').offsetTop;
      this.filterSticky = filterY - clientH - windowY > -55;
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .contentproduct * {
  font-family: Alibaba PuHuiTi,serif !important;
  font-size: 14px !important;
}
/deep/ .contentproduct table tr td {
  padding: 5px 10px;
  border: 1px solid #DDD;
}
/deep/ .contentproduct p a {
  color: #027ac2;
  text-decoration: underline;
}

/deep/ .el-input__icon {
  font-size: 1.1428rem;
  color: #333;
}

/deep/ .el-input__suffix {
  height: 32px;
}

/deep/ .el-input__suffix .el-input__icon{
  color: #c0c4cc;
  line-height: 32px;
}

/deep/ .el-input-group__append {
  padding: 0;
}

/deep/ .el-input-group__append .el-icon-search {
  padding: 8px 20px;
  cursor: pointer;
}
.pages {
  position: relative;
  min-height: 100%;
  background-color: #fff;

  .d-guide {
    height: 6rem;
    line-height: 6rem;
    color: #999999;
  }

  .top {
    height: 6rem;
    line-height: 6rem;
  }
  .pTitle {
    margin: 1rem 0 0;
    text-align: left;
    font-size: 1.875rem;
    font-family: YouSheBiaoTiHei,serif;
    font-weight: 400;
    color: #666;
  }
  .pBox {
    text-align: left;

    .p-Img {
      width: 100%;
      height: 50%;
    }
  }

  .d-filter {
    background: #f2f2f2;

    .facab {
      padding: 0.5rem 0;
      span {
        cursor: pointer;
      }

      .el-dropdown{
        margin: 0 0.5rem;
        font-size: 1rem;
      }

      .Link {
        padding: 0 0.5rem;
        margin: 0 0.5rem;
        border-radius: 0.2rem;

        &:hover {
          background: #635796;
          color: #FFF;
        }
      }
    }

    .mlf20 {
      margin: 0 1.25rem;
    }

    .filterBox {
      background: #f2f2f2;
      padding: 0.5rem;
      color: #808080;
      span {
        margin-right: 1rem;
      }
      .title {
        margin-right: 0;
        color: #666666;
      }
      .number {
        margin-right: 0;
        color: #409EFF;
      }
    }

    .d-search {
      margin: .5rem 0;
      width: 14.75rem;
    }
  }
  @media screen and (max-width: 1400px) {
    .top,
    .d-filter{
      padding: 0 2%;
    }
    .pTitle {
      padding: 0 2%;
    }
    .pBox {
      padding: 0 2% 0.625rem;
      .contentproduct {
        width:96%;
      }
    }
  }
  @media screen and (min-width: 1400px) {
    .top,
    .d-filter{
      padding: 0 10%;
    }
    .pTitle {
      padding: 0 10%;
    }
    .pBox {
      padding: 0 10% 0.625rem;
      .contentproduct {
        width:80%;
      }
    }
  }
  @media screen and (min-width: 1700px) {
    .top,
    .d-filter{
      padding: 0 15%;
    }
    .pTitle {
      padding: 0 15%;
    }
    .pBox {
      padding: 0 15% 0.625rem;
      .contentproduct {
        width:70%;
      }
    }
  }
}

.reset-search {
  &:hover {
    cursor: pointer;
  }
}

.sticky {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
}

.table-title {
  height: 3.2rem;
  background: #b3b3b3;

  .td-none {
    width: 100%;
    padding: 50px;
    text-align: center;
    background: #ebebeb;
  }

  .t-th {
    height: 5rem;
    background: #b3b3b3;
  }


  .td1 {
    width: 1.25rem;
    background: #dbdbdb;
  }

  .td-n {
    color: #5f5395;
    text-align: center;
  }

  .td-i {
    height: 3rem;
  }

  .td-i:nth-child(odd) {
    background: #ebebeb;
  }

  .td-i:nth-child(even) {
    background: #fafafa;
  }

  .td-r {
    width: calc(100% - 1.25rem);
  }

  .td2 {
    min-width: 50px;
    text-align: center;
  }

  .td13 {
    min-width: 4.75rem;
    text-align: center;
  }

  .td11 {
    min-width: 100px;
    text-align: center;
  }

  .td14 {
    min-width: 60px;
    text-align: center;
  }

  .td15 {
    //min-width: 12.5rem;
    min-width: 200px;
    text-align: center;
  }


  .th-n {
    //width: calc((100% - 8.75rem - 3.75rem) / 10);
    text-align: center;
  }

  .p-pages {
    height: 2.25rem;
    background: #dbdbdb;
    border: 1px solid #dbdbdb;
  }

  /deep/ .el-pager li {
    background: none;
  }

  /deep/ .el-pager li.active {
    color: #fff !important;
  }

  /deep/ .el-pager li:hover {
    color: #fff !important;
  }

  .td1 {
    width: 1.25rem;
    background: #dbdbdb;
  }
}

.el-dropdown-menu {
  padding: 20px 10px 10px;
}
.dropdown-list {
  overflow: auto;
  max-height: 200px;
  overflow-x: hidden;
  margin: 10px 0;
}
.dropdown-footer {
  text-align: center;
  box-sizing: border-box;
  margin-top: 20px;
  padding: 10px;
  border-top: 1px solid #d8d9dc;
  border-radius: 3px;
}
.btn {
  background: #635796;
  border-radius: 4px;
  border-color: #635796;
  color: #ffffff;
  padding: 7px 20px;
}
.btn-close {
  background: #FFF;
  border-radius: 4px;
  border-color: #DCDFE6;
  color: #606266;
  padding: 7px 20px;
}
</style>
